module.exports = __webpack_public_path__ + "static/guessANumber-167db728af4ce8a4ad917a34c42ab3c7.png";